import { render, staticRenderFns } from "./userGroupNew.vue?vue&type=template&id=9df7a1e6&"
import script from "./userGroupNew.vue?vue&type=script&lang=js&"
export * from "./userGroupNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports